"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Connect = exports.StandardConnect = void 0;
/** Name of the feature. */
exports.StandardConnect = 'standard:connect';
/**
 * @deprecated Use {@link StandardConnect} instead.
 *
 * @group Deprecated
 */
exports.Connect = exports.StandardConnect;
//# sourceMappingURL=connect.js.map